export default "__VITE_ASSET__f575ecd2__"